jQuery(function() {
  /**
   * GESTION DES ECHANTILLONS
   */

  // Première étape : on récupère tous les échantillons
  var samples = $('.sample-product__checkbox');

  // Deuxième étape : pour tous les échantillons déjà cochés, on les ajoute
  samples.each(function(idx, item) {
    var sample = $(item);

    if (!sample.is(':checked')) {
      return;
    }

    var hash = {};
    hash[sample.attr('data-sample-variant')] = 1;

   /* if (CartJS !== undefined) {
      CartJS.updateItemQuantitiesById(hash);
    } else {*/
      
      $.post('/cart/update.js', {updates: hash});
      
   // }
  });

  // Troisième étape : on attache un écouteur pour chaque input, et si on l'active/désactive on ajoute ou supprime l'échantillon
  $('.sample-product__checkbox').on('change', function() {
    var sample = $(this),
      hash = {},
      currentSamplesCount = samples.filter(':checked').length,
      maxSamplesCount = 2;

    // On rend les checkbox non cochées incliquables si on a déjà dépassé la limite d'échantillons
    if (currentSamplesCount >= maxSamplesCount) {
      samples.not(':checked').attr('disabled', 'disabled');
    } else {
      samples.not(':checked').removeAttr('disabled');
    }

    if (sample.is(':checked')) {
      hash[sample.attr('data-sample-variant')] = 1;
      sample.closest('.sample-product').addClass('sample-product--selected');
    } else {
      hash[sample.attr('data-sample-variant')] = 0;
      sample.closest('.sample-product').removeClass('sample-product--selected');
    }

   /* if (CartJS !== undefined) {
      CartJS.updateItemQuantitiesById(hash);
    } else {*/
    
      $.post('/cart/update.js', {updates: hash});
    //}
  });

  // On permet également de cliquer sur la "tuile" complète pour activer la checkbox
  $('.sample-product').on('click', function(event) {
    var target = $(event.target);

    if (target.prop('tagName') === 'INPUT') {
      return true;
    }

    var checkbox = target.closest('.sample-product').find('.sample-product__checkbox');

    if (!checkbox.attr('disabled')) {
      target.closest('.sample-product').find('.sample-product__checkbox').prop('checked', function(i, val) {
        return !val;
      }).trigger('change');
    }
  });

  /**
   * GESTION DE LA RECHERCHE
   *
   * Hélas, Shopify ne propose pas de moyen simple d'éviter à un produit d'apparaître dans la recherche. Hors, c'est exactement
   * ce que nous voulons pour nos échantillons.
   *
   * Ce code permet donc de manière transparente d'ajouter aux recherches l'élément "- product_type:Sample" qui permet de filtrer
   * tous les produits dont le type est "Sample"
   */

  $('form[action="/search"]').on('submit', function() {
    var form = $(this),
      q = form.find('[name="q"]');

    q.val(q.val() + '* -tag:__hidden');
  });
});